import React, {useEffect, useState} from "react";
import localization from "assets/localization/localization";
import ConstantInput from "../Input/constantInput/constantInput";
import DropDownInput from "../Input/dropDownInput/dropDownInput";

const RcCasesFilter = ({ applyFilter, rcFilter, localstorageKey }) => {
    const parseLocalStorage = () => {
        try {
            return JSON.parse(localStorage.getItem(localstorageKey) || {})
        } catch {
            return {};
        }
    };

    const initialFilterInputs = parseLocalStorage();
    const [filterFieldsData, setFilterFieldsData] = useState(initialFilterInputs);


    useEffect(() => {
        const storedData = parseLocalStorage();
        setFilterFieldsData({});
    }, []);

    const handleOnChange = (key, val) => {
        // let list = [...filterFieldsData];
        filterFieldsData[key] = val;
        setFilterFieldsData(filterFieldsData);
    }
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
            }}
        >
            {rcFilter.map((item, i) => {
                return (
                    <>
                        {parseInt(item?.primary) === 1 &&
                            <>
                                {item?.options && item?.options.length > 0 ?
                                    <DropDownInput
                                        label={item?.name}
                                        data={item?.options}
                                        getIdValue={(val) => {
                                            handleOnChange(item?.key, val.id)
                                        }}
                                        value={''}
                                    />
                                     :
                                    <ConstantInput
                                        label={item?.name}
                                        type={item?.data_type}
                                        handleChange={(val) => {
                                            handleOnChange(item?.key, val)
                                        }}
                                    />
                                }
                            </>
                        }
                    </>
                )
            })}
            <br />
            <br />
            <br />
            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src="../images/arrow-right.png" alt="" />
                </button>
                <br />
                <br />
                <button
                    onClick={() => {
                        setFilterFieldsData(initialFilterInputs);
                        applyFilter({});
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default RcCasesFilter;
